const TH = "text-left text-[9px] tracking-[0.14em] text-[var(--r2-text2)] font-normal pb-1";
const usd = (v) => (!v ? "—" : v >= 1e6 ? `$${(v / 1e6).toFixed(2)}M` : `$${(v / 1e3).toFixed(0)}k`);
const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(0)}%`);
const ago = (t) => { const m = Math.max(0, Math.round((Date.now() / 1000 - t) / 60)); return m >= 60 ? `${(m / 60).toFixed(1)}h` : `${m}m`; };

/* Uniswap v4 launches (ETH / USDG / stock-paired) — where the RH runners trade. Watch-only. */
export const RhV4Watch = ({ v4 }) => {
  const top = v4?.top || [];
  return (
    <div data-testid="rhchain-v4-watch">
      <div className="mb-1 text-[10px] text-[var(--r2-text2)]" data-testid="rhchain-v4-stats">
        {v4?.pools ?? 0} new v4 launches found · {v4?.tokens ?? 0} tracked (last 6h) · {v4?.runners ?? 0} crossed $1M · block {v4?.last_block ?? "—"}
        {v4?.last_error && <span className="ml-2 text-[var(--r2-amber)]">{v4.last_error}</span>}
      </div>
      {top.length === 0 ? <div className="text-[var(--r2-text2)]" data-testid="rhchain-v4-empty">scanning v4 launches — first marks land within a minute</div> : (
        <div className="max-h-72 overflow-auto">
          <table className="w-full"><thead><tr><th className={TH}>token</th><th className={TH}>pair</th><th className={TH}>mcap</th><th className={TH}>first seen</th><th className={TH}>peak</th><th className={TH}>liq</th><th className={TH}>1h</th><th className={TH}>age</th></tr></thead>
            <tbody>{top.map((r) => (
              <tr key={r.token} className="border-t border-[var(--r2-border)]" data-testid={`rhchain-v4-${r.token}`}>
                <td className="font-black"><a href={r.url} target="_blank" rel="noreferrer" className={r.runner_at ? "text-[var(--rh)]" : "hover:text-[var(--rh)]"}>{r.symbol}</a></td>
                <td className="text-[var(--r2-text2)]">{r.quote_symbol || r.quote_kind}</td>
                <td className="font-bold">{usd(r.mcap)}</td><td>{usd(r.first_mcap)}</td><td>{usd(r.peak_mcap)}</td><td>{usd(r.liq_usd)}</td>
                <td className={r.chg_1h > 0 ? "text-[var(--r2-emerald)]" : r.chg_1h < 0 ? "text-[var(--r2-red)]" : ""}>{pct(r.chg_1h)}</td><td>{ago(r.launched_at || r.found_at)}</td>
              </tr>))}</tbody></table>
        </div>)}
    </div>
  );
};
